<div class="container-fluid pt-3 pb-4 py-sm-5 px-sm-5">
  <app-header-title
    [dataTestId]="'update-post-title'"
    [titleHint]="'UPDATE_POST_TITLE_HINT'"
    [link]="LINK_POSTS_VIEW"
    [itemId]="post.entity_id"
    [title]="post.title"
  ></app-header-title>
  <div *ngIf="formContent" class="row justify-content-center">
    <div class="col-md-8">
      <app-form-constructor [formContent]="formContent"></app-form-constructor>
      <div class="mb-3">
        <small class="form-text text-muted" data-test-id="small-required">
          * - {{ 'REQUIRED_FIELD_HINT' | translate }}
        </small>
      </div>

      <div>
        <button
          class="btn btn-outline-primary me-3"
          type="button"
          data-test-id="btn-remove-post"
          (click)="onRemovePost()"
        >
          {{ 'POSTS_REMOVE_POST_TITLE' | translate }}
        </button>
      </div>
      <div class="py-4">
        <button
          appLongOperation
          class="btn btn-primary"
          type="submit"
          data-test-id="btn-update-post"
          (click)="updatePost($event)"
        >
          {{ 'BTN_SUBMIT_HINT' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-secondary pt-300 ms-3"
          data-test-id="btn-cancel-update-post"
          (click)="cancel()"
        >
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
